import PropTypes from 'prop-types';

export default PropTypes.shape({
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      avatar: PropTypes.shape({
        fluid: PropTypes.object
      }),
      name: PropTypes.string
    })
  ),
  category: PropTypes.oneOf([PropTypes.object, PropTypes.string, '']),
  id: PropTypes.string.isRequired,
  publishDate: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  title: PropTypes.string,
  slug: PropTypes.string.isRequired,
  localizationSlug: PropTypes.string,
  snippet: PropTypes.shape({
    snippet: PropTypes.string
  }),
  type: PropTypes.string,
  blogRichJSON: PropTypes.oneOf([PropTypes.object, '']),
  heroImageData: PropTypes.shape({
    fluid: PropTypes.object
  }),
  requireContentForm: PropTypes.bool,
  contentTitle: PropTypes.string,
  downloadableContent: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
      fileName: PropTypes.string,
      contentType: PropTypes.string
    })
  }),
  relatedInsights: PropTypes.arrayOf(
    PropTypes.shape({
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          avatar: PropTypes.shape({
            fluid: PropTypes.object
          }),
          name: PropTypes.string
        })
      ),
      id: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string,
      slug: PropTypes.string,
      snippet: PropTypes.string,
      category: PropTypes.string,
      heroImageData: PropTypes.shape({
        fluid: PropTypes.object
      })
    })
  )
});
